import AccommodationRequest from './AccommodationRequest';

export default AccommodationRequest;
